import { DictionaryKeysEnum } from "./enums/DictionaryKeysEnum"

export const dictionariesFetchConfig: {
  key: DictionaryKeysEnum
  url: string
}[] = [
  { key: DictionaryKeysEnum.Countries, url: "/v1/dictionary/countries" },
  { key: DictionaryKeysEnum.CryptoAssets, url: "/v1/dictionary/crypto-assets" },
  { key: DictionaryKeysEnum.Currencies, url: "/v1/dictionary/currencies" },
  { key: DictionaryKeysEnum.Operations, url: "/v1/dictionary/operations" },
  {
    key: DictionaryKeysEnum.PaymentMethods,
    url: "/v1/dictionary/payment-methods",
  },
  {
    key: DictionaryKeysEnum.PaymentSystemStatuses,
    url: "/v1/dictionary/payment-systems-statuses",
  },
  {
    key: DictionaryKeysEnum.PaymentSystemSubmethods,
    url: "/v1/dictionary/payment-systems-submethods",
  },
  {
    key: DictionaryKeysEnum.TransactionStatuses,
    url: "/v1/dictionary/transaction-statuses",
  },
  { key: DictionaryKeysEnum.Types, url: "/v1/dictionary/event-object-types" },
  { key: DictionaryKeysEnum.Sources, url: "/v1/dictionary/event-sources" },
]
